import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@ds';
import { CaseFormType } from '@features/forms/CaseForms/schema';

type ReallocationCheckboxProps = {
  isDisabled?: boolean;
};

export const ReallocationCheckbox = memo(({ isDisabled }: ReallocationCheckboxProps) => {
  const { control, setValue } = useFormContext<CaseFormType>();

  const handleValueChange = (value: boolean) => {
    setValue('reAllocationCase', value);
    if (!value) {
      setValue('reAllocationCaseId', null);
    }
  };

  return (
    <Controller
      name="reAllocationCase"
      control={control}
      render={({ field: { ref, onChange, ...field } }) => (
        <Checkbox
          {...field}
          size="md"
          value="reAllocationCase"
          isSelected={field.value}
          isDisabled={isDisabled}
          onValueChange={handleValueChange}
        >
          Re-allocation
        </Checkbox>
      )}
    />
  );
});
